import {ChangeDetectionStrategy, Component, ViewEncapsulation} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-announcements-list-my",
    template: `
        <h1 class="container-heading">My announcements</h1>
        <mat-card>
            <mat-card-content>
                <section-announcements-list [only_my]="true" [state]="state"></section-announcements-list>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class AnnouncementsListMyComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "support-announcements-my",
            actions: {
                "browse": ["browse_announcements"]
            }
        };
    }
}
